<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" (click)="save()">
        {{ (email?.id ? 'misc.save_btn' : 'misc.create_btn') | translate }}
      </button>
    </div>
  </div>
</ng-template>

@if (email) {
  <app-tab-switcher
    [config]="[
    {link: '/administration/emails/' + this.email!.id, translationKey: 'authenticated.administration.emails.edit.tabs.details', exact: true},
    {link: '/administration/emails/' + this.email!.id + '/german', translationKey: 'authenticated.administration.emails.edit.tabs.german', exact: true},
    {link: '/administration/emails/' + this.email!.id + '/english', translationKey: 'authenticated.administration.emails.edit.tabs.english', exact: true},
    {link: '/administration/emails/' + this.email!.id + '/russian', translationKey: 'authenticated.administration.emails.edit.tabs.russian', exact: true},
  ]"
  ></app-tab-switcher>
}

<div class="row g-3">

  <div class="col-12 col-md-9 order-md-1">
    <div class="card mb-3">
      <div class="card-body">

        <div class="row">

          <div class="col-12 py-1">
            <app-form-group
              [formControl]="getFormControl('subject')"
              label="{{'authenticated.administration.emails.content.form.subject.label' | translate }}"
              [errorMessages]="{required: ('authenticated.administration.emails.content.form.subject.validation_messages.required' | translate)}"
            ></app-form-group>
          </div>

          <div class="col-12 py-1" style="min-height: 300px">
            <div class="form-group">
              <label for="pre_content_markdown" class="form-label">
                {{ 'authenticated.administration.emails.content.form.pre_content.label' | translate }}
              </label>

              @if (getFormControl('pre_content').touched && getFormControl('pre_content').invalid) {
                <div class="text-danger">
                  {{ 'authenticated.administration.emails.content.form.pre_content.validation_messages.required' | translate }}
                </div>
              }
            </div>

            <ngx-monaco-editor
              id="pre_content_markdown"
              style="height: 100%"
              [options]="{theme: 'vs-dark', language: 'markdown'}"
              [formControl]="getFormControl('pre_content')"
            ></ngx-monaco-editor>
          </div>

          <div class="col-12 py-1" style="min-height: 300px">
            <div class="form-group">
              <label for="content_markdown" class="form-label">
                {{ 'authenticated.administration.emails.content.form.content.label' | translate }}
              </label>

              @if (getFormControl('content').touched && getFormControl('content').invalid) {
                <div class="text-danger">
                  {{ 'authenticated.administration.emails.content.form.content.validation_messages.required' | translate }}
                </div>
              }
            </div>

            <ngx-monaco-editor
              id="content_markdown"
              style="height: 100%"
              [options]="{theme: 'vs-dark', language: 'markdown'}"
              [formControl]="getFormControl('content')"
            ></ngx-monaco-editor>
          </div>

          <div class="col-12 py-1" style="min-height: 300px">
            <div class="form-group">
              <label for="post_content_markdown" class="form-label">
                {{ 'authenticated.administration.emails.content.form.post_content.label' | translate }}
              </label>

              @if (getFormControl('post_content').touched && getFormControl('post_content').invalid) {
                <div class="text-danger">
                  {{ 'authenticated.administration.emails.content.form.post_content.validation_messages.required' | translate }}
                </div>
              }
            </div>

            <ngx-monaco-editor
              id="post_content_markdown"
              style="height: 100%"
              [options]="{theme: 'vs-dark', language: 'markdown'}"
              [formControl]="getFormControl('post_content')"
            ></ngx-monaco-editor>
          </div>

        </div>

      </div>
    </div>
  </div>

  <div class="col-12 col-md-3 order-md-2">
    <div class="card mb-3">
      <div class="card-header">
        {{ 'authenticated.administration.emails.content.actions_card.header' | translate }}
      </div>
      <div class="card-body">
        <button type="button" class="btn btn-secondary w-100" (click)="showPreview()" [disabled]="!formIsValid">
          {{ 'authenticated.administration.emails.content.actions_card.preview_btn' | translate }}
        </button>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header">
        {{ 'authenticated.administration.emails.content.placeholder_card.header' | translate }}
      </div>
      <div class="card-body placeholder-card-body row">
        @for (placeholder of Object.values(EmailPlaceholderEnum); track placeholder) {
          <div class="col-12 col-xxl-4 mb-0 mb-xxl-2">{{ 'enums.emailPlaceholderEnum.' + placeholder | translate }}:</div>
          <div class="col-12 col-xxl-8 mb-2 user-select-all d-flex align-items-end">{{ '{{-- ' + placeholder + ' --}}' }}</div>
        }
      </div>
    </div>
  </div>

</div>


@if (email) {
  <app-email-preview
    [email]="email"
    [previewData$]="emailPreviewData$"
    [form]="form"
  ></app-email-preview>
}
